/**
 * FilterPopUpDetailsReducer.
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export const FilterDirectReporteeTrainingPopUpDetailsReducer = (state = {}, action) => {
  switch (action.type) {
    case 'GET_DIRECT_REPORTEE_TRAINING_POPUP_FILTER_DATA':
      return {
        ...state,
        popupFilterData: action.payload,
      };
    case 'API_START':
      if (action.payload === 'FETCHT_DIRECT_REPORTEE_TRAINING_POPUP_FILTER_DATA') {
        return {
          ...state,
          isLoadingDirectReporteeTrainingFilterData: true,
        };
      } else {
        return state;
      }
    case 'API_END':
      if (action.payload === 'FETCHT_DIRECT_REPORTEE_TRAINING_POPUP_FILTER_DATA') {
        return {
          ...state,
          isLoadingDirectReporteeTrainingFilterData: false,
        };
      } else {
        return state;
      }
    default:
      return state;
  }
};
